/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiCompanyDtoCompanyAddUserFromInviteDto
 */
export interface WebApiCompanyDtoCompanyAddUserFromInviteDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiCompanyDtoCompanyAddUserFromInviteDto
     */
    inviteId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiCompanyDtoCompanyAddUserFromInviteDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiCompanyDtoCompanyAddUserFromInviteDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiCompanyDtoCompanyAddUserFromInviteDto
     */
    password?: string | null;
}

/**
 * Check if a given object implements the WebApiCompanyDtoCompanyAddUserFromInviteDto interface.
 */
export function instanceOfWebApiCompanyDtoCompanyAddUserFromInviteDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiCompanyDtoCompanyAddUserFromInviteDtoFromJSON(json: any): WebApiCompanyDtoCompanyAddUserFromInviteDto {
    return WebApiCompanyDtoCompanyAddUserFromInviteDtoFromJSONTyped(json, false);
}

export function WebApiCompanyDtoCompanyAddUserFromInviteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiCompanyDtoCompanyAddUserFromInviteDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'inviteId': !exists(json, 'inviteId') ? undefined : json['inviteId'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'password': !exists(json, 'password') ? undefined : json['password'],
    };
}

export function WebApiCompanyDtoCompanyAddUserFromInviteDtoToJSON(value?: WebApiCompanyDtoCompanyAddUserFromInviteDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'inviteId': value.inviteId,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'password': value.password,
    };
}

